<template>
  <mdb-container fluid v-bind:style="{fontFamily: 'OpenSans-Regular', fontSize: '12px'}">
    <h2 class="mt-lg-4" style="font-family: OpenSans-bold; margin-bottom: -10px;">
      <strong>Contratistas de obra</strong>
    </h2>
    <!--Section: Horizontal stepper-->
    <section class="my-5">
      <!--Card-->
      <mdb-card cascade>
        <!--Card image-->
        <div
          class="price white-text rounded-top"
          v-bind:style="{padding: '1rem 2rem', textAlign: 'left', background: '#026ab4', fontFamily: 'OpenSans-Regular', fontSize: '16px', lineHeight: '1.38'}"
        >
          <span>
            <img
              alt="icono contratista"
              src="https://d39vj9j1h6phln.cloudfront.net/apps/myfrac/admin/assets/Contratistas_Icon@3x.png"
              class="img-fluid"
              style="width: 28px; height: 26px"
            />
          </span>
          &nbsp; {{TitleHeader}}
          <div class="text-right" style=" margin-top: -10px; margin-right: -20px; float: right;">
            <mdb-tooltip material trigger="hover" :options="{placement: 'top'}">
              <span slot="tip">Descartar registro</span>
              <mdb-btn
                slot="reference"
                outline="white"
                rounded
                size="sm"
                class="px-2 style_BTN"
                @click="remove"
              >
                <mdb-icon icon="times" class="mt-0" />
              </mdb-btn>
            </mdb-tooltip>
          </div>
        </div>

        <!--/Card image-->

        <!--Card content-->
        <mdb-card-body>
          <form id="form2" class="needs-validation" novalidate @submit="checkFormContractor">
            <mdb-row class="form-row">
              <!--Form content-->
              <mdb-col md="4">
                <mdb-col md="10">
                  <mdb-row>
                    <p class="Datos-del-registro">Datos del registro</p>
                  </mdb-row>
                </mdb-col>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label
                        for="firtsName"
                        style="font-family: OpenSans-Semibold; font-size: 12px"
                      >Nombre</label>
                      <input
                        type="text"
                        class="form-control text-input"
                        id="firstName"
                        required
                        placeholder="Nombre"
                        maxlength="64"
                        v-model="form.firstName"
                        style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%;"
                      />
                      <div class="valid-feedback">Correcto</div>
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label
                        for="email"
                        style="font-family: OpenSans-Semibold; font-size: 12px; width: 100%;"
                      >Correo electrónico</label>
                      <input
                        v-show="disabledEmail"
                        disabled
                        type="text"
                        class="form-control text-input"
                        id="email"
                        required
                        pattern="[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                        placeholder="Correo electrónico"
                        maxlength="64"
                        v-model="formEmail"
                        style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%;"
                      />
                      <input
                        v-show="!disabledEmail"
                        type="text"
                        class="form-control text-input"
                        id="email"
                        required
                        pattern="^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                        placeholder="Correo electrónico"
                        maxlength="64"
                        v-model="formEmail"
                        style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%;"
                      />
                      <div class="valid-feedback">Correcto</div>
                      <div
                        class="invalid-feedback"
                      >Por favor, introduzca un correo con formato email@example.com</div>
                    </div>
                  </mdb-col>
                </mdb-row>
              </mdb-col>
              <mdb-col md="4">
                <mdb-col md="10">
                  <mdb-row>
                    <p class="Datos-del-registro"></p>
                  </mdb-row>
                </mdb-col>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label
                        for="lastName"
                        style="font-family: OpenSans-Semibold; font-size: 12px"
                      >Apellidos</label>
                      <input
                        type="text"
                        class="form-control text-input"
                        id="lastName"
                        required
                        placeholder="Apellidos"
                        maxlength="64"
                        v-model="form.lastName"
                        style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%;"
                      />
                      <div class="valid-feedback">Correcto</div>
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label
                        for="company"
                        style="font-family: OpenSans-Semibold; font-size: 12px"
                      >Empresa</label>
                      <input
                        type="text"
                        class="form-control text-input"
                        id="company"
                        required
                        placeholder="Empresa"
                        maxlength="64"
                        v-model="form.company"
                        style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%;"
                      />
                      <div class="valid-feedback">Correcto</div>
                    </div>
                  </mdb-col>
                </mdb-row>
              </mdb-col>
              <mdb-col md="4">
                <mdb-col md="10">
                  <mdb-row>
                    <p class="Datos-del-registro"></p>
                  </mdb-row>
                </mdb-col>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <label
                        for="phone"
                        style="font-family: OpenSans-Semibold; font-size: 12px"
                      >Teléfono</label>
                      <input
                        type="number"
                        class="form-control text-input"
                        id="phone"
                        placeholder="Teléfono del contratista"
                        maxlength="10"
                        v-model="formPhone"
                        style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%"
                      />
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group"></div>
                  </mdb-col>
                </mdb-row>
              </mdb-col>
            </mdb-row>
            <mdb-row class="form-row">
              <!--Address content-->
              <mdb-col md="4">
                <mdb-col md="10">
                  <mdb-row>
                    <p style="font-family: OpenSans-Semibold; font-size: 12px">Dirección</p>
                  </mdb-row>
                </mdb-col>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <input
                        type="text"
                        class="form-control text-input"
                        id="street"
                        required
                        placeholder="Calle"
                        maxlength="200"
                        v-model="form.street"
                        style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%;"
                      />
                      <div class="valid-feedback">Correcto</div>
                    </div>
                  </mdb-col>
                </mdb-row>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <input
                        type="text"
                        class="form-control text-input"
                        id="city"
                        required
                        placeholder="Ciudad"
                        maxlength="200"
                        v-model="form.city"
                        style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%;"
                      />
                      <div class="valid-feedback">Correcto</div>
                    </div>
                  </mdb-col>
                </mdb-row>
              </mdb-col>
              <mdb-col md="4">
                <mdb-col md="10">
                  <mdb-row>
                    <p class="Datos-del-registro"></p>
                  </mdb-row>
                </mdb-col>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <input
                        type="number"
                        class="form-control text-input"
                        id="number"
                        required
                        placeholder="Número"
                        maxlength="8"
                        v-model="form.number"
                        style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%;"
                      />
                      <div class="valid-feedback">Correcto</div>
                    </div>
                  </mdb-col>
                </mdb-row>
              </mdb-col>
              <mdb-col md="4">
                <mdb-col md="10">
                  <mdb-row>
                    <p class="Datos-del-registro"></p>
                  </mdb-row>
                </mdb-col>
                <mdb-row>
                  <mdb-col md="11">
                    <div class="form-group">
                      <input
                        type="number"
                        class="form-control text-input"
                        id="cp"
                        required
                        placeholder="Código postal"
                        maxlength="5"
                        v-model="form.cp"
                        style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%;"
                      />
                      <div class="valid-feedback">Correcto</div>
                    </div>
                  </mdb-col>
                </mdb-row>
              </mdb-col>
            </mdb-row>
            <mdb-row style="padding-left: 35%">
              <mdb-col md="2">
                <button
                  type="button"
                  class="waves-effect waves-dark btn btn-next btn-color-prev"
                  @click="remove()"
                >Cancelar</button>
              </mdb-col>
              <mdb-col md="2">
                <mdb-btn
                  type="submit"
                  class="waves-effect waves-dark btn btn-next btn-color-next"
                >{{TextButton}}</mdb-btn>
              </mdb-col>
              <!--Buttons content-->
            </mdb-row>
          </form>
        </mdb-card-body>
        <!--/.Card content-->
      </mdb-card>
      <!--/.Card-->
    </section>
    <!--Section: Horizontal stepper-->
    <!--Modal edit invited -->
  </mdb-container>
</template>
<script>
/* eslint-disable */
import Swal from "sweetalert2";
import Axios from "axios";
import Servers from "../../../server.js";
import {
  mdbContainer,
  mdbTooltip,
  mdbView,
  mdbCard,
  mdbCardImage,
  mdbCardHeader,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbCardUp,
  mdbCardAvatar,
  mdbCardGroup,
  mdbInput,
  mdbRow,
  mdbCol,
  mdbTextarea,
  mdbIcon,
  mdbBtn
} from "mdbvue";

export default {
  name: "createContractor",
  components: {
    mdbTooltip,
    mdbContainer,
    mdbView,
    mdbCard,
    mdbCardImage,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardUp,
    mdbCardAvatar,
    mdbCardGroup,
    mdbInput,
    mdbTextarea,
    mdbRow,
    mdbCol,
    mdbIcon,
    mdbBtn
  },
  data() {
    return {
      urlServer: Servers.serverApi,
      imgServer: Servers.serverImg,
      disabledEmail: false,
      TextButton: "Registrar",
      TitleHeader: "Registrar contratista",
      formUuid: "",
      formEmail: "",
      formPhone: "",
      form: {
        //uuid:"",
        firstName: "",
        lastName: "",
        //phone: "",
        //email: "",
        company: "",
        street: "",
        number: "",
        cp: "",
        city: ""
      }
    }; // END RETURN
  },
  methods: {
    getOneContractor(uuid){
       let aux = this;
       this.TextButton="Guardar"
       this.TitleHeader="Editar contratista";
      return Axios.get(this.urlServer + "api/contractors/" + uuid, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(response => {
          aux.formUuid = response.data.uuid
          aux.form.firstName = response.data.firstName
          aux.form.lastName = response.data.lastName
          aux.formPhone = response.data.phone
          aux.formEmail = response.data.user.email
          aux.form.company = response.data.enterprise
          var streetaux = response.data.fullAddress.split(',')[0]
          aux.form.street =  streetaux.split(' ')[1]
          var numberaux = response.data.fullAddress.split('#')[1]
          aux.form.number = numberaux.split(' ')[0]
          aux.form.cp = response.data.fullAddress.split(':')[1]
          aux.form.city = streetaux.split(' ')[0]
        
        })
        .catch(error => {
          aux.showMessageError("Ha ocurrido un error", error.response.data);
        });

    },
    remove() {
      window.location.href = "/contractors";
    },
    cleanForm() {
        this.formUuid = "";
      (this.form.firstName = ""),
        (this.form.lastName = ""),
        (this.formPhone = ""),
        (this.formEmail = ""),
        (this.form.company = ""),
        (this.form.street = ""),
        (this.form.number = ""),
        (this.form.cp = ""),
        (this.form.city = "");
    },
    checkFormContractor(event) {
      event.preventDefault();
      event.target.classList.add("was-validated");
      var valid = this.validateForm(this.form);
      var re = RegExp("^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$")
      if(re.test(this.formEmail) && valid){


      if(this.$route.query.token !=undefined){
         var data = {
        "firstName": this.form.firstName,
        "lastName": this.form.lastName,
        "phone": this.formPhone,
        "enterprise": this.form.company,
        "fullAddress":
          this.form.street +
          ", #" +
          this.form.number +
          ", CP." +
          this.form.cp +
          ", " +
          this.form.city
      }
      let aux = this;

      Axios.put(this.urlServer + "api/contractors/"+this.$route.query.token, data, {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(function(response) {
          aux.showMessageSucces("¡Contratista actualizado!");
          window.location.href="/contractors"
        })
        .catch(error => {
          console.log(error.response);
          aux.showMessageError("Ha ocurrido un error", error.response.data);
        });
      

      }
      else{

      var data = {
        "firstName": this.form.firstName,
        "lastName": this.form.lastName,
        "phone": this.formPhone,
        "enterprise": this.form.company,
        "fullAddress":
          this.form.city +
          " " +
          this.form.street +
          " #" +
          this.form.number +
          " C.P.:" +
          this.form.cp,
        "email": this.formEmail
      }
      let aux = this;

      Axios.post(this.urlServer + "api/contractors", data, {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(function(response) {

         Swal.fire({
        title: "<span style='font-size: 20px;'>Contratista creado correctamente</span>",
        html: "<span style='font-size: 12px;'>Para continuar con el proceso, por favor mencione al contratista que revise su correo</span>",
        type: "success",
        width: "30%",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () =>{
         window.location = "/contractors";
        }
      });
          /*Swal.fire({
            title:
              "<span style='font-size: 16px; font-weight: 400; color: #ffffff; margin-top: 10px; margin-right: auto; font-family: OpenSans-Regular;'><img src = '../../../static/Alerta_Icon_white.png' class='img-fluid' style='width: 19.2px; height: 15.3px; margin-top: -5px;'></img>&nbsp!Alta de contratista exitosa</span>",
            html:
              '<div><div class="form-row" style=" font-family: OpenSans-Regular;' +
              "font-size: 12px;" +
              "font-weight: normal;" +
              "font-style: normal;" +
              "font-stretch: normal;" +
              "line-height: 1.42;" +
              "letter-spacing: normal;" +
              "text-align: center;" +
              'color: #000000;">A continuación se muestran los datos del contratista que se ha dado de alta recientemente:</div>' +
              '<div class="form-row" style="margin-top: 2rem;">' +
              '<p style="font-size: 1rem;"><span style="font-size: 14px; font-weight: bold; font-family: OpenSans-Bold;">USUARIO:</span>&nbsp'+response.data.email+'</p>' +
              "<br>" +
              '<p style="font-size: 1rem;"><span style="font-size: 14px; font-weight: bold; font-family: OpenSans-Bold;">CONTRASEÑA:</span>&nbsp'+response.data.password+'</p>' +
              "</div>" +
              "</div>",
            showCancelButton: true,
            width: "30%",
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
            reverseButtons: true,
            customClass: {
              header: "Rect-BG",
              confirmButton: "btn-modal-accept",
              cancelButton: "btn-modal-cancel"
            }
          }).then(result => {
              window.location = "/contractors";
          });*/
        })
        .catch(error => {
          console.log(error.response);
          aux.showMessageError("Ha ocurrido un error", error.response.data);
        });
      }

  
      }
    },
    validateForm(form){
       return (
        Object.keys(form).length ===
        Object.keys(form).filter(key => form[key].length > 0).length
      );
    },
    
     showMessageError: function(text, error) {
      let aux = this;
      let errorText;
      Swal.fire({
        title: "<span style='font-size: 20px'>" + text + "</span>",
        html: "<span style='font-size: 12px'>" + error + "</span>",
        imageUrl: "../../../static/Cancel_icon.png",
        imageWidth: "22%",
        imageHeight: "auto",
        width: "30%",
        //confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () => {}
      });
    },
    showMessageSucces: function(text) {
      Swal.fire({
        title: "<span style='font-size: 20px;'>Correcto</span>",
        html: "<span style='font-size: 12px;'>" + text + "</span>",
        type: "success",
        width: "30%",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () =>{
          //window.location.reload();
        }
      });
    }
    
  },
  created() {},
  mounted() {

     if (this.$route.query.token != undefined) {
       this.disabledEmail=true;
      this.getOneContractor(this.$route.query.token);
     }

  },
  update() {},
  watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.Datos-del-registro {
  width: auto;
  height: 19px;
  font-family: OpenSans-Bold;
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
}




.btn.btn-edit {
  padding: 0.2rem 0.4rem;
  font-size: 0.64rem;
  border-radius: 7px;
  width: 24px;
  height: 23p;
}

.form-csv {
  height: 170px;
  width: 300px;
  margin: 0 auto;
  border-radius: 2px;
  border: 1px solid #e8e9ec;
  background-color: #ffffff;
}

.form-csv h5,
.form-csv h6 {
  width: 100%;
  color: #545871;
}

.form-csv input {
  position: absolute;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100px;
  outline: none;
  opacity: 0;
}

.form-csv input:hover {
  cursor: pointer;
}

.form-csv:hover {
  opacity: 0.7;
  border: 4px dashed #676d6d;
}

.Rectangle-536 {
  width: 190px;
  height: 37px;
  border-radius: 4px;
  border: solid 1px #e8e9ec;
  background-color: #ffffff;
}

.Rectngulo-1673 {
  width: 161.6px !important;
  height: 37px !important;
  border-radius: 3px !important;
  border: solid 1px #e8e9ec;
  background-color: #ffffff;
}

.Rectngulo-650 {
  width: 1112.7px;
  height: 500.8px;
  border-radius: 25px;
  border: solid 2px #bce0fd;
  background-color: #ffffff;
}

.save-btn {
  font-size: 10px;
  float: right;
}


.text-width {
  width: auto;
}

.text-input {
  width: auto;
}

.btn-next {
  text-transform: capitalize !important;
  border-radius: 7px !important;
  width: 110px !important;
  height: 39px !important;
  padding: 0px 0px !important;
}

.btn-prev {
  text-transform: capitalize !important;
  border-radius: 7px !important;
  width: 110px !important;
  height: 39px !important;
  padding: 0px 0px !important;
}

.btn-final {
  text-transform: capitalize !important;
  border-radius: 7px !important;
  width: 110px !important;
  height: 39px !important;
  padding: 0px 0px !important;
}

.btn-color-next {
  background-color: #23a7ed !important;
  color: #fff !important;
}

.btn-color-prev {
  background-color: #ed5f5f !important;
  color: #fff !important;
}

.btn-modal-accept {
  height: 50% !important;
  width: auto !important;
  background-color: #3085d6 !important;
  font-size: 12px !important;
}

.btn-modal-cancel {
  height: 50% !important;
  width: auto !important;
  background-color: #d33 !important;
  font-size: 12px !important;
}

.btn-modal-download {
  height: 50% !important;
  width: auto !important;
  background-color: #a4a8ab !important;
  font-size: 12px !important;
}

.style_BTN {
  width: 31.2px;
  object-fit: contain;
}


</style>
<style scoped>
.modal-header {
  width: 112%;
  height: 44px;
  background-color: #67a3cf;
  margin-left: -6%;
  margin-bottom: 20px;
  margin-top: -20px;
}
</style>
